import { useMemo } from 'react';
import {
  SystemClassifierCode,
  SystemClassifierItemDto,
} from '../systemClassifier';
import { useSystemClassifierItems } from './useSystemClassifierItems';

export const useSystemClassifierItem = (
  code: SystemClassifierCode,
  itemCode: string
): SystemClassifierItemDto | undefined =>
  useSystemClassifierItems(code, [itemCode])[0];

export const useSystemClassifierItemById = (
  code: SystemClassifierCode,
  itemId?: number
): SystemClassifierItemDto | undefined => {
  const items = useSystemClassifierItems(code);

  return useMemo(() => {
    if (itemId) {
      return items.find((item) => item.id === itemId);
    }
    return undefined;
  }, [itemId, items]);
};
